import Pagination from "../../components/Pagination";

export default {
    components: {Pagination},
    data() {
        return {
            isLoading: true,
            locations: [],
            filteredLocations: [],
            search: '',
            links: {},
            page: 1
        }
    },
    methods: {
        filterLocations() {
            this.page = 1;
            this.start();
        },
        start() {
            this.$api.get('locations.index', {page: this.page, search: this.search})
                .then(res => {
                    this.filteredLocations = res.data;
                    this.links = res.links;
                    // this.filterLocations();
                })
                .finally(() => {
                    this.isLoading = false;
                })
        },
        deleteItem(item) {
            let index = this.filteredLocations.indexOf(item);
            if (index >= 0 && confirm(this.i18n('Do you really want to delete this flight?'))) {
                this.$api.delete('locations.delete', item.id)
                    .then(res => {
                        if (!res.errors) {
                            this.filteredLocations.splice(index, 1);
                        }
                    })
            }
        },
        lockOrUnlock(item, status) {
            let data = item;
            data.status = status ? 10 : 5;
            this.$api.put('locations.update', data, item.id)
                .then(res => {
                    if (!res.errors) {
                        item = res.data;
                    }
                })
        }
    },
    beforeRouteUpdate(to, from, next) {
        let page = to.params.page;
        if (page) {
            this.page = page;
            this.start();
        }
        next();
    },
    created() {
        this.start();
    },
    mounted() {

    }
}
